interface VCValuationResponse {
  value: number;
  method: string;
  timestamp: string;
  sheetName: string;
  error?: string;
}

export const fetchVCValuation = async (): Promise<VCValuationResponse> => {
  const scriptUrl = 'https://script.google.com/macros/s/AKfycbwZd7s6LTuILmnFWJBxxY3xj4I8yV16b7_wG-mwlev-3DQ4aOSR1H37H2ejksxvITQ/exec';
  
  try {
    const response = await fetch(scriptUrl);
    const data = await response.json();
    
    if (data.error) {
      throw new Error(data.error);
    }
    
    return data;
  } catch (error) {
    console.error('Error fetching VC valuation:', error);
    throw error;
  }
}; 